import { User } from "../models/users.model";

/**
 * Returns the current user
 */
function loggedInUser(): User | null {
    let user: User | null = {};
    user = JSON.parse(sessionStorage.getItem('cayc-user')!);
    return user;
}

export { loggedInUser }

